import styled from "styled-components";

export const AdvancedTabsGroupTemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DesignContainer = styled.div`
  height: 160px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.border.black15};
  display: grid;
  place-content: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: ${({ theme }) => `linear-gradient(
      90deg,
      ${theme.text.white}00 0%,
      ${theme.text.white}40 85%,
      ${theme.text.white}FF 100%
    )`};
    z-index: 10;
  }

  & > div {
    transform: scale(1.5);
    margin-left: 100px;
  }
`;
